<template>
  <div class="card shadow-sm" style="width: 450px">
    <div class="card-header">
        <h3 class="card-title">
          <div class="form-check">
              <input class="form-check-input" type="checkbox" v-if="$can(abilities.TEMPLATE_CONFIG_VIEW)" v-model="online" @click="chooseTemplate" id="flexCheckDefault" />
              <label class="ms-2 form-check-label text-primary" for="flexCheckDefault">
                {{ $t('default') }}
              </label>
          </div>
        </h3>
    </div>
    <div class="card-body">
        <img :src="template.file_url" width="400px"/>
    </div>
</div>
</template>

<script setup>
import {ref} from 'vue'
import abilities from "@/composables/abilities";

const emits = defineEmits(['submit'])

const props = defineProps({
  id: {
    type: String,
    default: ''
  },
  template: {
    type: Object,
    default: {
      id: '',
      module: ''
    }
  }
}) 

const online = ref(props.template.default)

function chooseTemplate(){
  if(!online.value) emits('submit', {id: props.template?.id, module: props.template?.module})
}
</script>

<style scoped>
</style>
